<div class="form-group">
    <label [for]="id" [ngClass]="{ 'text-danger': !valid}">{{label | translate}}</label>
    <tag-input [id]="id" class="form-control" secondaryPlaceholder="{{initialPlaceholder | translate}}" placeholder="{{correctPlaceHolder | translate}}" [(ngModel)]="value"
        [disabled]="disabled" [ngClass]="{ 'is-invalid': !valid}"></tag-input>
    <small *ngIf="!valid" class="form-text text-muted danger"><em>{{errorMessage}}</em></small>
</div>